import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { formatStartTime } from 'lib/util/formatStartTime';
import { ProductShape } from 'lib/util/productShape';
import { LocationList } from '../LocationList/LocationList';

interface Props {
  product: ProductShape;
}

export const PickupCheckinTab = ({ product }: Props) => {
  const { t } = useTranslation();

  const [selectedTimeSlotKey, setSelectedTimeSlotKey] = React.useState<string>(
    product.startTimes.length > 0 ? product.startTimes[0].timeSlotKey : ''
  );
  const handleStartTimeChange = (event: React.ChangeEvent<HTMLSelectElement>) =>
    setSelectedTimeSlotKey(event.target.value);

  const showPickupSection = product.pickupLocations.length > 0;
  const showCheckinSection = product.checkinLocations.length > 0;

  const selectedStartTime = product.startTimes.find(
    (startTime) => startTime.timeSlotKey === selectedTimeSlotKey
  );

  return (
    <div className="c-schedule">
      <label className="c-schedule__select">
        <select name="startTime" value={selectedTimeSlotKey} onChange={handleStartTimeChange}>
          {product.startTimes.map((startTime) => (
            <option key={startTime.timeSlotKey} value={startTime.timeSlotKey}>
              {formatStartTime(startTime)}
            </option>
          ))}
        </select>
      </label>
      {showPickupSection && (
        <>
          <p className="c-schedule__headline">{t('Pickup Locations / Times')}</p>
          <LocationList startTime={selectedStartTime} locations={product.pickupLocations} />
        </>
      )}
      {showCheckinSection && (
        <>
          <p className="c-schedule__headline">{t('Checkin Times / Locations')}</p>
          <LocationList startTime={selectedStartTime} locations={product.checkinLocations} />
        </>
      )}
    </div>
  );
};
